import useWindowSize from '~/hooks/useWindowSize';
import CustomizePackageCard from '~/pages/Packages/CustomizePackageCard';
import PlanCard from '~/pages/Packages/PlanCard';
import {
  getPackagesGridClass,
  PackagesGridPlanType,
} from '~/pages/Packages/utils';
import { PackageTierType } from '~/types/packagesType';
import { useGetUserQuery } from '~/redux/api/userApiSlice';
import AddonSection from '~/pages/Packages/AddonSection';
import { useBreakpoint } from '~/hooks';

export default function CompaniesPackages({
  plans,
  onTiersClick,
}: {
  plans: PackagesGridPlanType[];
  onTiersClick: (tiers: PackageTierType[], name: string | null) => void;
}) {
  const { mobileScreen } = useBreakpoint();
  const { width } = useWindowSize();

  const { data: userResponse } = useGetUserQuery();

  const hasActiveSubscription = Boolean(
    userResponse?.user?.hasActiveSubscription,
  );

  const addonsPlans = hasActiveSubscription
    ? plans.filter((plan) => plan.is_top_up)
    : [];

  const mainPlans = plans.filter((plan) => !plan.is_top_up);

  const totalCardsCount = mainPlans.length + 1;

  return (
    <div className="layout-boundary">
      <div
        className={`layout-boundary__inner px-2x md:px-0 ${getPackagesGridClass(totalCardsCount, width)}`}
      >
        {mainPlans.map((plan) => (
          <div
            key={plan.key}
            className="packages-card-item packages-card-item--companies"
          >
            <PlanCard
              plan={plan}
              mobileScreen={mobileScreen}
              onTiersClick={onTiersClick}
              allowActivationFees
            />
          </div>
        ))}
        <div className="packages-card-item packages-card-item--companies">
          <CustomizePackageCard />
        </div>
      </div>

      {addonsPlans.length ? (
        <div className="layout-boundary__inner mt-[40px] md:mt-[48px] px-2x md:px-0">
          <AddonSection addonsPlans={addonsPlans} />
        </div>
      ) : null}
    </div>
  );
}
